import * as React from "react";
const SvgRestaurant = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M10.536 4.057a.75.75 0 1 0-.572 1.386c.315.13.647.44.91.848.125.193.214.378.275.537l-.037.027a3.545 3.545 0 0 0-.63.625c-.353.443-.732 1.108-.732 1.776 0 .26.044.511.126.744H7a.75.75 0 0 0 0 1.5h4.25v7.75a.75.75 0 0 0 1.5 0V11.5H17a.75.75 0 0 0 0-1.5h-2.875c.081-.233.125-.483.125-.744 0-.662-.365-1.325-.717-1.773a3.59 3.59 0 0 0-.52-.54c.208-.285.506-.59.86-.792a.75.75 0 0 0-.746-1.301c-.347.198-.66.454-.927.733a4.477 4.477 0 0 0-.066-.105c-.36-.557-.902-1.134-1.598-1.421Zm1.119 4.357c.124-.156.25-.278.351-.355.1.075.225.195.348.352.269.342.396.677.396.845 0 .375-.27.684-.623.744h-.254a.753.753 0 0 1-.623-.744c0-.162.129-.495.405-.842Z"
      fill="currentColor"
    />
    <path
      d="M2.378 7.099a.75.75 0 0 1 1.023.279l.375.655a6.75 6.75 0 0 1 .852 2.643l.274 2.6a.25.25 0 0 0 .248.224h3.6a.75.75 0 0 1 0 1.5h-.129l.62 4.139a.75.75 0 1 1-1.483.222L7.554 18H4.696l-.204 1.361a.75.75 0 0 1-1.484-.222l.729-4.857a1.744 1.744 0 0 1-.327-.849l-.274-2.6a5.25 5.25 0 0 0-.663-2.056L2.1 8.122A.75.75 0 0 1 2.378 7.1ZM4.921 16.5H7.33L7.104 15H5.146l-.225 1.5ZM21.622 7.099a.75.75 0 0 0-1.023.279l-.375.655a6.751 6.751 0 0 0-.852 2.643l-.273 2.6a.25.25 0 0 1-.25.224H15.25a.75.75 0 0 0 0 1.5h.13l-.622 4.139a.75.75 0 0 0 1.484.222L16.446 18h2.858l.204 1.361a.75.75 0 1 0 1.484-.222l-.729-4.857c.177-.242.294-.532.327-.849l.274-2.6a5.25 5.25 0 0 1 .663-2.056l.374-.655a.75.75 0 0 0-.279-1.023ZM19.08 16.5h-2.408l.225-1.5h1.958l.225 1.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgRestaurant;
